export const REQUEST_STATUS = {
  NONE: "NONE",
  STARTED: "STARTED",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const GENERATE_STATUS = {
  NONE: "NONE",
  STARTED: "STARTED",
  UPDATE_STARTED: "UPDATE_STARTED",
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
  UPDATE_FAILURE: "UPDATE_FAILURE",
  GENERATE_STARTED: "GENERATE_STARTED",
  GENERATE_SUCCESS: "GENERATE_SUCCESS",
  GENERATE_FAILURE: "GENERATE_FAILURE",
  DOWNLOAD_STARTED: "DOWNLOAD_STARTED",
  DOWNLOAD_SUCCESS: "DOWNLOAD_SUCCESS",
  SUCCESS: "SUCCESS",
};
